<template>
	<div class="sub-folder-indicator-line"></div>
</template>

<script>
export default {
	name: 'SubFolderIndicatorLine',
};
</script>

<style scoped lang="scss">
.sub-folder-indicator-line {
	$height: 45px;
	$width: 10px;
	$line-width: 2px;
	position: relative;
	width: $width;
	&:before,
	&:after {
		content: '';
		position: absolute;
		border-radius: $line-width;
	}
	&:before {
		width: $line-width;
		height: $height;
		background-color: var(--seconday-border-color);
	}
	&:after {
		top: #{$height - $line-width};
		width: $width;
		height: $line-width;
		background-color: var(--seconday-border-color);
	}
}
</style>
